import { Utils } from "../Utils/Utils";
import Control from "./Control";
export default class SelectControl extends Control {
    constructor(field, isMain = true) {
        super(field);
        this.isMain = true;
        this.isMain = isMain;
        if (!Utils.isOk(this.field.placeHolder))
            this.field.placeHolder = " - Please Select - ";
    }
    renderField() {
        let ret = [];
        ret.push(`<div ${this.isMain ? " data-main" : ""} id="${this.field.internalId}">`);
        if (this.field.selectionFieldSettings.allowCustomValue) {
            ret.push(`<div class="row-two-controls">`);
            ret.push(`<input type="radio" name="${this.field.internalId}_radio_group" group-controls=${this.field.internalId} 
            id="${this.field.internalId}_option_selection" value="0"
            ${!(this.initialValue && this.initialValue.isCustomValue)
                ? " checked"
                : ""}
        >`);
            ret.push(...this.renderSelectWithOptions());
            ret.push("</div>");
            ret.push('<div class="row-two-controls">');
            ret.push(`<input type="radio" name="${this.field.internalId}_radio_group" 
        group-controls=${this.field.internalId} id="${this.field.internalId}_custom_other_selection" value="1"
        ${this.initialValue && this.initialValue.isCustomValue ? " checked" : ""}
        >`);
            ret.push(`<input type="text" disabled id="${this.field.internalId}_custom_option_value" group-controls=${this.field.internalId}  
        placeholder="Other" 
        ${this.initialValue &&
                this.initialValue.isCustomValue &&
                this.initialValue.customValue
                ? " value='" + this.initialValue.customValue + "'"
                : ""}
        >`);
            ret.push("</div>");
        }
        else {
            ret.push(...this.renderSelectWithOptions());
        }
        ret.push("</div>");
        return ret.join("");
    }
    renderPreview() {
        var _a, _b, _c;
        const initialValue = this.initialValue;
        const value = initialValue ?
            initialValue.isCustomValue
                ? initialValue.customValue
                : (_c = (_b = (_a = this.field.selectionFieldSettings) === null || _a === void 0 ? void 0 : _a.options) === null || _b === void 0 ? void 0 : _b.find((o) => o.optionId === (initialValue === null || initialValue === void 0 ? void 0 : initialValue.valueId))) === null || _c === void 0 ? void 0 : _c.optionValue
            : "";
        return `<span>${value !== null && value !== void 0 ? value : ""}</span>`;
    }
    renderSelectWithOptions() {
        var _a, _b;
        let ret = [];
        ret.push(`<select id=${this.field.internalId}_select ${this.isRequired() ? " required" : ""}>`);
        ret.push(`<option disabled selected value="">${this.field.placeHolder} </option>`);
        (_b = (_a = this.field.selectionFieldSettings) === null || _a === void 0 ? void 0 : _a.options) === null || _b === void 0 ? void 0 : _b.forEach((option) => {
            ret.push(`<option value="${option.optionId}"${this.initialValue && this.initialValue.valueId === option.optionId
                ? " selected"
                : ""}>${option.optionValue}</option>`);
        });
        ret.push("</select>");
        return ret;
    }
    getSelectionValue() {
        const selectField = (document.querySelector(`#control_${this.field.internalId} select`));
        let radioValue = "0";
        if (this.field.selectionFieldSettings.allowCustomValue) {
            const radio = document.querySelectorAll(`#control_${this.field.internalId} input[type="radio"]:checked`);
            radioValue = radio[0].value;
        }
        const otherField = (document.querySelector(`#control_${this.field.internalId} input[type="text"]`));
        let ret = {
            isCustomValue: radioValue === "1",
            customValue: radioValue === "1" ? otherField === null || otherField === void 0 ? void 0 : otherField.value : "",
            valueId: radioValue === "0" ? selectField === null || selectField === void 0 ? void 0 : selectField.value : "",
            lovValueId: null,
        };
        return ret;
    }
    getValue() {
        return JSON.stringify(this.getSelectionValue());
    }
    validate(clearValidationMessages = true, ghostMode = false) {
        const valid = super.validate(clearValidationMessages, ghostMode);
        if (!valid) {
            let value = this.getSelectionValue();
            if (value.isCustomValue) {
                this.field.validationMessages[0] +=
                    ' Please make sure that the "Other" field is not empty.';
            }
        }
        return valid;
    }
    getRawValue() {
        let value = this.getSelectionValue();
        return value.isCustomValue ? value.customValue : value.valueId;
    }
    customValueChange() {
        const otherField = (document.querySelector(`#control_${this.field.internalId} input[type="text"]`));
        const selectField = (document.querySelector(`#control_${this.field.internalId} select`));
        const radio = document.querySelector(`#control_${this.field.internalId} input[type="radio"]:checked`);
        if (radio) {
            const radioValue = radio.value;
            if (radioValue === "1") {
                selectField.disabled = true;
                otherField.disabled = false;
            }
            else {
                selectField.disabled = false;
                otherField.disabled = true;
            }
        }
    }
    afterRender() {
        if (this.field.selectionFieldSettings.allowCustomValue) {
            const radios = document.querySelectorAll(`#control_${this.field.internalId} input[type="radio"]`);
            radios.forEach((radio) => radio.addEventListener("change", this.customValueChange));
        }
        super.afterRender();
    }
    onChange(validate = true) {
        this.customValueChange();
        super.onChange(validate);
    }
    updateOptions(options, placeholder) {
        const selectField = (document.querySelector(`#control_${this.field.internalId} select`));
        // Reset options
        selectField.options.length = 0;
        // If placeholder is needed, create a disabled option for it
        if (placeholder) {
            let placeholderOption = document.createElement("option");
            placeholderOption.selected = true;
            placeholderOption.disabled = true;
            placeholderOption.value = "";
            placeholderOption.text = placeholder;
            selectField.appendChild(placeholderOption);
        }
        // Create options and set selected option on field when needed
        options.forEach((fieldOption) => {
            var _a;
            let option = document.createElement("option");
            if (fieldOption.optionId === ((_a = this.initialValue) === null || _a === void 0 ? void 0 : _a.valueId)) {
                option.selected = true;
            }
            option.value = fieldOption.optionId;
            option.text = fieldOption.optionValue;
            selectField.appendChild(option);
        });
    }
}
